import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  FetchPartnerConfigurationsRequest,
  FetchPartnerConfigurationsResponse,
} from '../../dto/partner-configuration-dto';

type FetchPartnerConfigurationOptions = Partial<
  Omit<IHttpRequest<void>, 'body'>
> & {
  httpCall?: IHttpCall;
};

export function fetchPartnerConfiguration(
  baseUrl: string,
  payload: FetchPartnerConfigurationsRequest,
  options?: FetchPartnerConfigurationOptions,
): Promise<IHttpResponse<FetchPartnerConfigurationsResponse>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<FetchPartnerConfigurationsRequest> = {
    url: `${baseUrl}/api/v1/partner-configurations/search-partner/`,
    method: 'GET',
    headers,

    queryParams: {
      ...payload,
    },
    schemas: {
      query: FetchPartnerConfigurationsRequest,
      response: FetchPartnerConfigurationsResponse,
    },
    next: {
      revalidate: 180,
    },
    ...restOptions,
  };

  return httpCall(request);
}
